import { CommonModule } from '@angular/common'
import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { FormsModule } from '@angular/forms'
import { NbButtonModule, NbFormFieldModule, NbIconModule, NbInputModule, NbSelectModule, NbTooltipModule } from '@nebular/theme'
import { EmailComposerStateService, EmailComposerView } from '../../services/email-composer-state.service'

@Component({
  selector: 'ngx-composer-header',
  templateUrl: './composer-header.component.html',
  styleUrls: ['./composer-header.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, NbButtonModule, NbInputModule, NbFormFieldModule, NbIconModule, NbSelectModule, NbTooltipModule]
})
export class ComposerHeaderComponent implements OnInit {
  @Input() activeView: EmailComposerView = 'templates'
  @Output() viewChange = new EventEmitter<EmailComposerView>()

  search = ''
  private readonly _destroyRef = inject(DestroyRef)

  constructor(private state: EmailComposerStateService) {}

  ngOnInit(): void {
    this.state.search$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((s) => (this.search = s))
  }

  switch(view: EmailComposerView) {
    this.viewChange.emit(view)
    this.state.setActiveView(view)
  }

  onSearch(value: string) {
    this.state.setSearch(value)
  }

  // Helper methods to check if parent view is active (including child views)
  public isTemplatesViewActive(): boolean {
    return this.activeView === 'templates' || this.activeView === 'template-editor'
  }

  public isComponentsViewActive(): boolean {
    return this.activeView === 'components' || this.activeView === 'component-editor'
  }

  public isThemesViewActive(): boolean {
    return this.activeView === 'themes' || this.activeView === 'theme-editor'
  }

  public isActionsViewActive(): boolean {
    return this.activeView === 'actions' || this.activeView === 'action-editor'
  }
}
